import { render, staticRenderFns } from "./UploadedCard.vue?vue&type=template&id=51d09afe&scoped=true&"
import script from "./UploadedCard.vue?vue&type=script&lang=js&"
export * from "./UploadedCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadedCard.vue?vue&type=style&index=0&id=51d09afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d09afe",
  null
  
)

export default component.exports